/**
 * PageSkeleton — minimal Suspense fallback.
 *
 * A 2px top progress bar, no full-page chrome. The previous page stays
 * visible underneath while the next chunk loads, eliminating the white
 * flash on every navigation. Used both as the global Suspense fallback
 * and on first-paint cold loads.
 */
export const PageSkeleton = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-0.5 z-[100] pointer-events-none overflow-hidden bg-transparent"
    >
      <div
        className="h-full bg-primary"
        style={{
          width: "40%",
          animation: "page-skeleton-progress 1.1s ease-in-out infinite",
        }}
      />
      <style>{`
        @keyframes page-skeleton-progress {
          0%   { transform: translateX(-150%); }
          60%  { transform: translateX(200%); }
          100% { transform: translateX(400%); }
        }
      `}</style>
    </div>
  );
};

export default PageSkeleton;
